import { FC } from "react";
import { Modal } from "../../../components/Modal";
import { Button } from "../../../components/Button";
import "./style.css";

interface Props {
  isOpen: boolean;
  isUpdating: boolean;
  version: string;
  changelogRecordsAmount: number;
  onConfirm: () => void;
  onClose: () => void;
}

export const ChangelogConfirmationModal: FC<Props> = ({
  isOpen,
  isUpdating,
  version,
  changelogRecordsAmount,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal isOpen={isOpen}>
      <div className="changelog-confirmation-modal">
        <p>
          Are you sure you want to accept <span>{changelogRecordsAmount}</span>{" "}
          changelog records for version
          <br />
          <span>{version}</span>?
        </p>
        <Button onClick={onConfirm} disabled={isUpdating}>
          {isUpdating ? "Updating..." : "Accept"}
        </Button>
        <Button version="secondary" onClick={onClose}>
          Decline
        </Button>
      </div>
    </Modal>
  );
};
